import Vue from 'vue'
import Vuex from 'vuex'
import config from './store/modules/config'
import text from './store/modules/text'
import app from './store/modules/app'
import country from './store/modules/country'
import option from './store/modules/option'
import popup from './store/modules/popup'
import popupQuiz from './store/modules/popupQuiz'
import popupTourism from './store/modules/popupTourism'
import register from './store/modules/register'
import gps from './store/modules/gps'
import locale from './store/modules/locale/index'
import event from './store/modules/event/index'
import entry from './store/modules/entry'
import info from './store/modules/info'
import message from './store/modules/message'
import user from './store/modules/user'
import bank from './store/modules/bank'
import answer from './store/modules/answer/index'
import tourism from './store/modules/tourism'
import quiz from './store/modules/quiz'
import quizset from './store/modules/quizset'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    config,
    text,
    app,
    country,
    option,
    popup,
    popupQuiz,
    popupTourism,
    register,
    gps,
    locale,
    event,
    entry,
    info,
    message,
    user,
    bank,
    answer,
    tourism,
    quiz,
    quizset
  }
})

store.subscribeAction({
  before: (action, state) => {
    store.commit('config/setOnline')
    if (!state.config.online) {
      window.alert('ネットワークに接続していません。')
    }
  }
})

export default store
